import { LinearGradient } from "expo-linear-gradient";
import React from "react";
import { View, Text, StyleSheet } from "react-native";

type QuizProgressBarProps = {
  current: number;
  total: number;
};

const QuizProgressBar: React.FC<QuizProgressBarProps> = ({
  current,
  total
}) => {
  const progress = total > 0 ? current / total : 0;

  return (
    <View style={styles.progressContainer} data-oid="rao-yja">
      <Text style={styles.progressText} data-oid="f:dox1v">
        {`Q${current + 1} of ${total}`}
      </Text>
      <View style={styles.progressBarOuter}>
        <View style={styles.progressBarTrack}>
          <LinearGradient
            colors={["#4F46E5", "#6366F1"]}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 0 }}
            style={[
              styles.progressBarFill,
              { width: `${progress * 100}%` }
            ]}
          >
            <View style={styles.progressBarGlow} />
          </LinearGradient>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  progressContainer: {
    marginBottom: 36,
    marginTop: 10,
    paddingHorizontal: 24,
    alignItems: 'center',
    width: '100%',
    maxWidth: 480,
    alignSelf: 'center'
  },
  progressText: {
    textAlign: 'center',
    color: '#4F46E5',
    fontWeight: 'bold',
    fontSize: 22,
    marginBottom: 14,
    letterSpacing: 0.5
  },
  progressBarOuter: {
    width: '100%',
    alignItems: 'center'
  },
  progressBarTrack: {
    width: '100%',
    height: 18,
    backgroundColor: '#E8E6EF',
    borderRadius: 9,
    overflow: 'hidden'
  },
  progressBarFill: {
    height: '100%',
    borderRadius: 12,

    position: 'relative',
    justifyContent: 'center'
  },
  progressBarGlow: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    borderRadius: 12,

    zIndex: -1
  }
});

export default QuizProgressBar;
